import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput';

const SearchForm = ({
	handleSubmit,
  hasFocus,
  onBlur,
  onFocus
}) => {
  let searchClass = 'search-box';
  if(hasFocus) {
    searchClass += ' focus';
  }

	return (
		<form className={searchClass} onSubmit={handleSubmit}>
			<Field name="searchPhrase"
              id="searchPhrase" 
              component={FormInput} 
              type="text" 
              className="form-control"
              onBlur={onBlur}
              onFocus={onFocus}
              placeholder={I18n.t('PET_SEARCH_PLACEHOLDER')} 
      />
      <span className="input-group-btn">
        <button className="btn btn-secondary btn-search" type="submit"><i className="fa fa-search lg" /></button>
      </span>
    </form>
	);
};

SearchForm.propTypes = {
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hasFocus: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm()(SearchForm);


/** WEBPACK FOOTER **
 ** ./src/modules/search/components/SearchForm.js
 **/